/**
 * Created by fers on 24/08/2017.
 */
import {AlertList, AlertContainer} from "react-bs-notifier";
import {FormattedMessage, defineMessages, IntlProvider} from 'react-intl';
import ReactDOM from 'react-dom';
import React from 'react';
import Relay from 'react-relay';
import {sendError} from './errorDisplayer';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import JobProgress from '../jobs/JobProgress.react';
import meQuery from '../queries/MeQuery';

import './notification.scss';
import '../layout.scss';

// have only one instance of error dialog
let notificationInstance = null;

class Notification extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            alerts: []
        };

        notificationInstance = this; // eslint-disable-line consistent-this

    }

    componentWillUnmount() {
        notificationInstance = null;
    }

    onAlertDismissed(alert) {
        const alerts = this.state.alerts;

        // find the index of the alert that was dismissed
        const idx = alerts.indexOf(alert);

        if (idx >= 0) {
            this.setState({
                // remove the alert from the array
                alerts: [...alerts.slice(0, idx), ...alerts.slice(idx + 1)]
            });
        }
    }

    clearAlerts() {
        this.setState({
            alerts: []
        });
    }

    addAlert(newAlert) {
        this.setState({
            alerts: [...this.state.alerts, newAlert]
        });
    }

    render() {
        /* we are using require instead of classic 'import' - this code must be able to run on server-side and import locales.po is not supported */
        let locales = require('../locales');
		let getMessagesDefault = require('../getMessages');
        let {getLocale} = locales;
		let {getMessages} = getMessagesDefault;

        return (
            <IntlProvider locale={getLocale()} messages={getMessages()}>
                <AlertContainer position="top-right">
                    <AlertList
                        alerts={this.state.alerts}
                        onDismiss={this.onAlertDismissed.bind(this)}
                    />
                </AlertContainer>
            </IntlProvider>
        );
    }
}

const messages = defineMessages({
    backgroundJobTitle: {id: 'channel.jobTitle', 'defaultMessage': 'Background job started.'},
    backgroundFlowTitle: {id: 'channel.flowInvocationTitle', 'defaultMessage': 'Background flow invoked.'},
});

export function showJobNotification(intl, job, text : string) {
    let url;

    if (job.organisation_id) {
        url = urlMapping.getUrl(types['jobs'], 'view', {organisation_id: job.organisation_id, id: job.realId});
    } else {
        url = urlMapping.getUrl(types['jobs'], 'user-view', {id: job.realId});
    }

	const queryConfig = {
		queries: meQuery,
		name: 'User',
		params: {
			jobId: job.realId
		}
	};

    showNotification(text || intl.formatMessage(messages.backgroundJobTitle),
        <div className="jobProgress">
			<div className="layout-row">
				<div className="flex-none"><FormattedMessage defaultMessage="Progress:" id="job.progressTitle" />&nbsp;</div>
				<div className="flex progressWrapper">
					<Relay.Renderer
						Container={JobProgress}
						environment={Relay.Store}
						queryConfig={queryConfig}
					/>
				</div>
			</div>
            <a className="alert-link" href={url} target="_blank"> <FormattedMessage defaultMessage="View details" id="channel.viewDetails" /></a>
        </div>);
}

export function showFlowInvocationNotification(intl, flowInvocation, text : string) {
    let url = urlMapping.getUrl(types['flowInvocations'], 'view', flowInvocation);
    showNotification(text || intl.formatMessage(messages.backgroundJobTitle),
        <span>
            <a className="alert-link" href={url} target="_blank"> <FormattedMessage defaultMessage="See progress." id="channel.watchFlow`Progress" /></a>
        </span>);
}

export default function showNotification(title, content) {
    try {
        if (!notificationInstance) {
            let notificationDiv = document.createElement('div');
            notificationDiv.style = "z-index: 2000; position: fixed; top: 1em; right: 2em left: 2em;";
            document.body.appendChild(notificationDiv);

            ReactDOM.render(
                <Notification></Notification>,
                notificationDiv
            );
        }

        return notificationInstance.addAlert({
            id: (new Date()).getTime(),
            type: 'success',
            headline: title,
            message: content
        });
    } catch (e) {
        sendError(e);
    }

}
